import { render, staticRenderFns } from "./form-multigroup.vue?vue&type=template&id=6fb0394c&"
import script from "./form-multigroup.vue?vue&type=script&lang=js&"
export * from "./form-multigroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports